import React, { useEffect, useState } from "react";
import { Button } from "./button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavOnPage = props => {
  var {
    color,
    links
  } = props;
  var [headerIDs, setHeaderIDs] = useState([]);
  useEffect(() => {
    var mainSection = document.querySelector("section") || document.querySelector("[data-theme]");
    var headerElements = mainSection == null ? void 0 : mainSection.querySelectorAll("h1, h2, h3, h4, h5, h6");
    var headerInfo = [];
    headerElements == null ? void 0 : headerElements.forEach(headerElement => {
      var _textNode$textContent;

      //eslint-disable @typescript-eslint/no-explicit-any
      var textNode = headerElement;

      while (textNode.firstChild !== null) {
        textNode = textNode.firstChild;
      }

      headerElement.id = "header-" + ((_textNode$textContent = textNode.textContent) == null ? void 0 : _textNode$textContent.toLowerCase().replace(/ /g, "-"));
      headerInfo.push(headerElement.id);
    });
    setHeaderIDs(headerInfo);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: "flex flex-wrap w-full gap-2",
    children: links.map(link => {
      if (!link.headingText) return;
      var id = "header-" + link.headingText.toLowerCase().replace(/ /g, "-");

      if (!headerIDs.includes(id)) {
        return process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? null : /*#__PURE__*/_jsxs("div", {
          children: ["Sorry the Heading Text of ", /*#__PURE__*/_jsx("strong", {
            children: link.headingText
          }), " does not match a heading on this page, please try again"]
        }, id);
      }

      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          width: "fit-content",
          color: color,
          href: "#" + id,
          children: link.linkText
        })
      }, id);
    })
  });
};
//# sourceMappingURL=nav_on_page.js.map